import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

interface LocationState {
    lat: number;
    lon: number;
    address: string;
}

interface WeddingLocationContextType {
    location: LocationState | null;
    setLocation: (loc: LocationState | null) => void;
    clearLocation: () => void;
}

const WeddingLocationContext = createContext<WeddingLocationContextType | undefined>(undefined);

export function WeddingLocationProvider({ children }: { children: ReactNode }) {
    const [location, setLocationState] = useState<LocationState | null>(() => {
        // Try to load from localStorage
        const saved = localStorage.getItem('wedding_location');
        return saved ? JSON.parse(saved) : null;
    });

    const setLocation = (loc: LocationState | null) => {
        setLocationState(loc);
        if (loc) {
            localStorage.setItem('wedding_location', JSON.stringify(loc));
        } else {
            localStorage.removeItem('wedding_location');
        }
    };

    const clearLocation = () => {
        setLocation(null);
    };

    return (
        <WeddingLocationContext.Provider value={{ location, setLocation, clearLocation }}>
            {children}
        </WeddingLocationContext.Provider>
    );
}

export function useWeddingLocation() {
    const context = useContext(WeddingLocationContext);
    if (context === undefined) {
        throw new Error('useWeddingLocation must be used within a WeddingLocationProvider');
    }
    return context;
}
